import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Row, Col, Select, DatePicker,message, Space } from 'antd';
import moment from 'moment';

import SPVehicleCascader from '../SPVehicleCascader';

import emiter, {
	EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH,
	EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH_FROM_SEARCH,
	EVENT_CARRENTAL_VEHICLE_OCCUPYMODAL_OPEN
} from '../../../../events'

import request from '../../../../request';
import { API_STORE_LIST_SELECT,API_VEHICLE_BRAND_LIST_NEW,API_VEHICLE_SERIES_LIST_NEW,API_VEHICLE_VEHICLE_LIST_NEW } from '../../../../hooks/carRental/_';
import MyModelCascader from "../../../product-price/base/vehicle-cascader-model";
import {DEFAULT_PAGE_INFO} from "../../../../consts";


interface PropsType {
	enums?: any;
}

const SPVehicleCalendarSearchForm: React.FC<PropsType> = props => {
	const { enums } = props;

	const [storeListOptions, setStoreListOptions] = useState<any>([]);

	const searchFormFields = {
		mendian: {
			name: 'store_code',
			label: '门店',
			required: true,
			message: '请选择门店',
			placeholder: '请输入',
		},
		riqi: {
			name: 'date',
			label: '日期',
			required: false,
			message: '请选择日期',
			placeholder: '请选择',
			extra: '*默认查询一个月'
		},
		chexing: {
		  name: 'vehicle_code',
			label: '车型',
			required: true,
			message: '请选择车型',
			placeholder: '请选择',
			extra:'请选择车型进行查询'
		}
	};

	const [searchForm] = Form.useForm();
	const [isShow, setIsShow] = useState(false);

	const getStoreList = () => {
		return request({
			url: API_STORE_LIST_SELECT,
			method: 'GET',
		}).then((res: any) => {
			if (!res.data || !res.data.length) {
				setStoreListOptions([]);
				searchForm.setFieldValue(searchFormFields.mendian.name, undefined);
				return;
			}
			setStoreListOptions(res.data);
			searchForm.setFieldValue(searchFormFields.mendian.name, res.data[0].store_code);
			searchForm.setFieldValue(searchFormFields.riqi.name, moment());
			setIsShow(true);
		}).catch(err => {
			message.error(err.message || '查询门店列表失败');
		});
	}

	const onSearchFormFinish = () => {
		emiter.emit(EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH,{
      ...searchForm.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
	 };

	const clearSearch = () => {
		searchForm.resetFields([searchFormFields.chexing.name, 'vehicle_code']);
		emiter.emit(EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH,{
      ...searchForm.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
	};

	useEffect(() => {
		emiter.on(EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH_FROM_SEARCH, onSearchFormFinish);
		getStoreList();
		return () => {
			emiter.removeAllListeners(EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH_FROM_SEARCH)
		}
	}, []);


	return (
		<>
			{isShow ?
				<Form form={searchForm} labelCol={{ span: 5 }} style={{ padding: 12 }} onFinish={onSearchFormFinish}>
			<Row gutter={24}>
				<Col span={8}>
					<Form.Item
						name={searchFormFields.mendian.name}
						label={searchFormFields.mendian.label}
						rules={[
							{
								required: searchFormFields.mendian.required,
								message: searchFormFields.mendian.message,
							},
						]}
					>
						<Select options={storeListOptions} fieldNames={{label:'store_name', value:'store_code'}}></Select>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						name={searchFormFields.chexing.name}
						label={searchFormFields.chexing.label}
						rules={[
							{
								required: searchFormFields.chexing.required,
								message: searchFormFields.chexing.message,
							},
						]}
						extra={searchFormFields.chexing.extra}
					>
						<MyModelCascader ></MyModelCascader>
					</Form.Item>
				</Col>
				<Col span={8}>
					<Form.Item
						name={searchFormFields.riqi.name}
						label={searchFormFields.riqi.label}
						rules={[
							{
								required: searchFormFields.riqi.required,
								message: searchFormFields.riqi.message,
							},
						]}
						extra={searchFormFields.riqi.extra}
					>
						<DatePicker></DatePicker>
					</Form.Item>
				</Col>
				<Col span={8} style={{ marginLeft: '18px' }}></Col>
			</Row>
			<div style={{ textAlign: 'left' }}>
				<Space>
					<Button type="primary" onClick={onSearchFormFinish}>
						查询
					</Button>
					<Button onClick={clearSearch}>清空</Button>
				</Space>
			</div>
		</Form>:null
				}
		</>
	);
};

export default SPVehicleCalendarSearchForm;
